import Richtext from './richtext';

export default class Reviews {
  title: string;
  primaryColor: string;
  secondaryColor: string;
  starColor: string;
  reviewItems: {
    id: string;
    rating: number;
    content: Richtext;
    meta: string;
  }[];
  scrollRatio: number;

  constructor(props: any) {
    this.title = props.title;
    this.primaryColor = props.primaryColor;
    this.secondaryColor = props.secondaryColor;
    this.starColor = props.starColor || props.secondaryColor;
    this.reviewItems = props.reviewItemsCollection.items;
    this.scrollRatio = props.scrollRatio || 1;
  }
}
